<template>
  <img :src="imgURL" :class="style['powered-by']">
</template>

<script>
import style from './scss/_poweredby_icon.scss'
import { poweredByLogos } from 'javascript/Constants'

export default {
  data: () => ({ style }),
  props: {
    icon: { type: String, default: 'gurunavi' }
  },
  computed: {
    imgURL () {
      return poweredByLogos[this.icon]
    }
  }
}
</script>
